<app-feature-details-grid>
  <ng-container *ngFor="let group of groupOfDevices">
    <app-feature-list-container *ngFor="let device of group.devices">
      <h3>{{ device?.roles | translateDeviceByRoles }}</h3>

      <!-- device name -->
      <ng-container *ngIf="getDeviceNameFeature(device.id) | async | ready as deviceName">
        <app-feature-list-item
          data-at-device-name
          [label]="'+INSTALLATIONS.SRC.DEVICE.DESCRIPTION' | translate"
          [editable]="true"
          [value]="deviceName | value2: featurePropertyKey.name"
          (edit)="openEditDeviceNameDialog(device.id)"
        >
        </app-feature-list-item>
      </ng-container>

      <!-- id -->
      <app-feature-list-item
        data-at-id
        [label]="'+INSTALLATIONS.SRC.DEVICE.ID' | translate"
        [value]="device?.id | idPrefixRemover | serialSpacing"
      >
      </app-feature-list-item>

      <!-- device error info message -->
      <ng-container
        *ngIf="activeErrorsStore.getActiveErrorsForSRCDevice(device?.id) | async as deviceErrors"
      >
        <app-feature-list-item
          data-ut-error
          *ngFor="let error of deviceErrors"
          [label]="error?.errorCode"
          [description]="error?.errorDescription"
          [value]="error?.appearedAt | date: 'short'"
          [error]="true"
        >
        </app-feature-list-item>
      </ng-container>

      <ng-container *ngIf="getFHTConnectionStatusFeature(device.id) | async | ready as status">
        <!-- Device disconnected alert -->
        <app-feature-list-item
          *ngIf="installationService.isSrcDeviceNotConnected(status)"
          [isNgContent]="true"
        >
          <app-banner>
            {{ '+INSTALLATIONS.SRC.ETRV.DISCONNECTED' | translate: { time: status.timestamp | date:
            'short' } }}
          </app-banner>
        </app-feature-list-item>

        <!-- wifi lqi -->
        <app-feature-list-item
          data-at-trv-wifi-lqi
          *ngIf="getWifiLqiFeature(device.id) | async | ready as feature"
          [error]="feature | error"
          [label]="'+INSTALLATIONS.SRC.ETRV.WIFI_LQI_STRENGTH.TITLE' | translate"
          [isNgContent]="true"
          timestamp="{{ feature?.timestamp | date: 'short' }}"
        >
          <ng-container
            *ngIf="
              feature?.properties?.strength &&
                feature?.properties?.strength?.value < lowLqiSignalThreshold;
              then lowSignal;
              else stableSignal
            "
            [attr.data-feature]="feature.feature + '/strength'"
          ></ng-container>

          <ng-template #lowSignal>
            <span class="warning-box">
              <mat-icon>error</mat-icon>
              {{ installationService.isSrcDeviceNotConnected(status) ? noValue : (feature | value2:
              featurePropertyKey.strength) + ' ' + (feature | unit: 'strength') }}</span
            >
          </ng-template>

          <ng-template #stableSignal>
            {{ installationService.isSrcDeviceNotConnected(status) ? noValue : (feature | value2:
            featurePropertyKey.strength) + ' ' + (feature | unit: 'strength') }}
          </ng-template>
        </app-feature-list-item>

        <!-- heating circuit -->
        <ng-container *ngIf="!(isSrcStandalone$ | async)?.properties?.active?.value">
          <app-feature-list-item
            data-at-trv-heating-circuit
            *ngIf="getHeatingIdFeature(device.id) | async | ready as feature"
            [label]="'+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate"
            value="{{
              installationService.isSrcDeviceNotConnected(status)
                ? noValue
                : (installationService.getCircuitName(feature.properties?.value?.value.toString())
                  | async)
            }}"
            [attr.data-feature]="feature.feature"
            [error]="feature | error"
          >
          </app-feature-list-item>
        </ng-container>

        <!-- active operating mode -->
        <app-feature-list-item
          data-at-trv-active-operating-mode
          *ngIf="getActiveOperatingModeFeature(device.id) | async | ready as feature"
          [label]="'+INSTALLATIONS.SRC.ETRV.ACTIVE_OPERATING_MODE.TITLE' | translate"
          value="{{
            installationService.isSrcDeviceNotConnected(status)
              ? noValue
              : (feature.properties?.value?.value | translateOperatingMode)
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>

        <!-- sensors temperature supply -->
        <app-feature-list-item
          data-at-trv-sensors-temperature-supply
          *ngIf="getFHTSensorsTemperatureSupplyFeature(device.id) | async | ready as feature"
          [label]="'+INSTALLATIONS.SRC.ETRV.SENSORS_TEMPERATURE_SUPPLY.TITLE' | translate"
          value="{{
            installationService.isSrcDeviceNotConnected(status)
              ? noValue
              : (feature | value2: featurePropertyKey.value) +
                ' ' +
                (feature | unit: featurePropertyKey.value)
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
        >
        </app-feature-list-item>

        <!-- FHT damage protection threshold -->
        <app-feature-list-item
          data-at-trv-damage-protection-threshold
          *ngIf="getFHTDamageProtectionThresholdFeature(device.id) | async | ready as feature"
          [label]="'+INSTALLATIONS.SRC.ETRV.DAMAGE_PROTECTION_THRESHOLD.TITLE' | translate"
          value="{{
            installationService.isSrcDeviceNotConnected(status)
              ? noValue
              : (feature | value2: featurePropertyKey.value) +
                ' ' +
                (feature | unit: featurePropertyKey.value)
          }}"
          [attr.data-feature]="feature.feature"
          [error]="feature | error"
          [editable]="!installationService.isSrcDeviceNotConnected(status)"
          (edit)="openFhtModal(device.id)"
        >
        </app-feature-list-item>
      </ng-container>

      <ng-container *ngIf="isRemoteDeviceOfType(device.roles, srcType.FHT)">
        <ng-container *ngIf="getFHTChannelsFeature() | async | ready as feature">
          <ng-container
            *ngIf="getFHTChannelsId(feature?.properties?.devices?.value, device.id) as fhtChannels"
          >
            <!-- FHT channels -->
            <app-feature-list-item
              data-at-number-of-channels
              [label]="'+INSTALLATIONS.SRC.ETRV.NUMBER_OF_FHT_CHANNELS_TITLE' | translate"
              [value]="fhtChannels?.length.toString()"
              [attr.data-feature]="'fHTChannels.length'"
              [error]="feature | error"
            >
            </app-feature-list-item>
            <!-- FHT channel Ids -->
            <app-feature-list-item
              data-at-trv-channel-ids
              [label]="'+SRC.DEVICE.SMART_ZIGBEE_FHT_CHANNELS' | translate"
              [value]="fhtChannels | serialSpacing"
              [attr.data-feature]="
                'getFHTChannelsId(feature.properties?.devices?.value, device.id)'
              "
              [error]="feature | error"
            >
            </app-feature-list-item>
          </ng-container>
        </ng-container>

        <!-- fht.configuration.demandRelayMode -->
        <app-feature-list-item
          data-at-fht-configuration-demandRelayMode
          *ngIf="getFHTDemandRelayModeFeature(device.id) | async | ready as feature"
          [label]="'+INSTALLATIONS.SRC.ETRV.FHT_DEMAND_RELAY_MODE.TITLE' | translate"
          [isNgContent]="true"
        >
          <mat-slide-toggle
            data-at-toggle-fht-configuration-demandRelayMode
            gtm="onToggle"
            gtmAction="FHT Demand Relay Mode"
            gtmCategory="singleRoomControl"
            [disabled]="!(feature | executable: FeatureCommands.setValue)"
            [checked]="feature.properties?.value?.value === fhtDemandRelayModeValues.automatic"
            (change)="onFHTDemandRelayModeChange($event, device.id)"
            [attr.data-feature]="feature.feature"
          ></mat-slide-toggle>
        </app-feature-list-item>
      </ng-container>

      <!-- device.sensors.firmware-->
      <app-feature-list-item
        data-at-cs-sensor-firmware
        *ngIf="firmware$ | async | ready as feature"
        [error]="feature | error"
        [label]="'+INSTALLATIONS.SRC.FIRMWARE' | translate"
        value="
            {{feature | value2: featurePropertyKey.value}}
          "
        [attr.data-feature]="feature.feature"
        timestamp="{{ feature.timestamp | date: 'short' }}"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </ng-container>
</app-feature-details-grid>
